import React from 'react'
import ReactDOM from 'react-dom/client'
import './index.scss'
import App from './app'
import reportWebVitals from './reportWebVitals'
import * as serviceWorkerRegistration from './serviceWorkerRegistration'

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()

// Habilita o service worker apenas em produção — necessário para instalar
// a PWA na tela de início do iOS/Android.
serviceWorkerRegistration.register()
